const API_BASE = process.env.REACT_APP_API_BASE || "";

export async function fetchComplexes(cityKey) {
  const url = `${API_BASE}/api/complexes?city=${encodeURIComponent(cityKey)}`;
  console.log("🔗 Запрос:", url);

  try {
    const res = await fetch(url, {
      // credentials: 'include', // если когда-нибудь понадобятся куки
      headers: { "Accept": "application/json" },
    });

    if (!res.ok) {
      const text = await res.text();
      console.error("❌ Ошибка ответа:", text);
      throw new Error(`Ошибка загрузки (HTTP ${res.status})`);
    }

    const data = await res.json();
    console.log("✅ Ответ данных:", data);
    return data;

  } catch (err) {
    console.error("💥 Ошибка запроса:", err);
    throw err;
  }
}

export async function fetchCitiesAvailability() {
  const url = `${API_BASE}/api/cities/availability`;

  try {
    const res = await fetch(url, {
      headers: { "Accept": "application/json" },
    });

    if (!res.ok) {
      const text = await res.text();
      console.error("Cities availability response error:", text);
      throw new Error(`Cities availability failed (HTTP ${res.status})`);
    }

    const data = await res.json();
    return data && typeof data === "object" && !Array.isArray(data) ? data : {};
  } catch (err) {
    console.error("Cities availability request failed:", err);
    throw err;
  }
}

export async function checkPhoneNumber(phone) {
  const res = await fetch(`${API_BASE}/api/phone-check`, {
    method: "POST",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ phone }),
  });

  if (!res.ok) {
    const error = new Error(`Phone check failed (HTTP ${res.status})`);
    error.status = res.status;
    throw error;
  }

  return res.json();
}
